import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { IAppointment, IAppointmentFiltersDTO } from '../types/interfaces/IAppointment';

export async function getAppointments(
  _filters: IAppointmentFiltersDTO
): Promise<ApiResponse<IAppointment[]>> {
  return apiClient.get<IAppointment[]>('/appointments');
}

export async function getAppointmentById(
  id: string
): Promise<ApiResponse<IAppointment>> {
  return apiClient.get<IAppointment>(`/appointments/${id}`);
}

export async function createAppointment(
  data: Omit<IAppointment, 'id'>
): Promise<ApiResponse<IAppointment>> {
  return apiClient.post<IAppointment>('/appointments', data);
}

export async function updateAppointment(
  id: string,
  data: Partial<IAppointment>
): Promise<ApiResponse<IAppointment>> {
  return apiClient.put<IAppointment>(`/appointments/${id}`, data);
}

export async function deleteAppointment(id: string): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`/appointments/${id}`);
}

export async function getUpcomingAppointments(
  days: number = 7,
  filters: IAppointmentFiltersDTO
): Promise<ApiResponse<IAppointment[]>> {
  const params = new URLSearchParams({ days: days.toString() });
  if (filters.specialtyId) params.append('specialty', filters.specialtyId);
  return apiClient.get<IAppointment[]>(`/appointments/upcoming?${params.toString()}`);
}
